import {CLEAR} from "./user";

export const SET_ACCOUNTS = 'user/SET_ACCOUNTS'
const initialState = [
   // {name:"foo",photos:[]} //Test data
]



export default (state = initialState, action) => {
    switch (action.type) {
        case SET_ACCOUNTS:
            let nstate = [
                //...state,
                ...action.data
            ];
            return nstate;
        case CLEAR:
            return initialState;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/modules/accounts.js